import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoFattureAttiveStep2Component } from './conservazione-carica-documento-fatture-attive-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-fatture-attive-step2', {
            url: '/conservazione-carica-fatture-attive',
            ncyBreadcrumb: {
                label: 'Carica Fattura Attive',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-fatture-attive-step2 flex="100"></conservazione-carica-documento-fatture-attive-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoFattureAttiveStep2Module: string = ng
    .module('conservazione-carica-documento-fatture-attive-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoFattureAttiveStep2', ConservazioneCaricaDocumentoFattureAttiveStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-fatture-attive-step2/conservazione-carica-documento-fatture-attive-step2.module.ts